import { BASEURL } from "../Constant";
import { INote, Note } from "../classes/Note";
import { TeamsUser } from "../classes/TeamsUser";

export class NotesService {

    /**
     * Liste des users avec lesquels l'utilisateur connecté peut communiquer
     */
    public static connectedUsers: TeamsUser[] = [];
    /**
     * L'utilisateur connecté à l'application
     */
    public static userProfile: TeamsUser ;

    /**
     * Ajoute une note sur le serveur
     * @param note La note à ajouter
     * @returns La note ayant été ajoutée
     */
    public static async addNote(note: Note): Promise<Note> {
        const headers = new Headers();
        headers.append("Content-Type", "application/json");

        const myInit: RequestInit = {
            method: "POST",
            headers: headers,
            body: JSON.stringify(note),
        };

        const res = await fetch(BASEURL + "/note", myInit);

        if(!res.ok || res.status !== 200) {
            console.error("addNote: ERROR in API call");
            throw new Error("ERROR in API call");
        }

        return new Note(await res.json());
    }

    /**
     * Modifie une note sur le serveur en servant de l'id de la note passée en paramère afin de l'identifier
     * @param note La note modifiée
     * @returns La note ayant été modifiée
     */
    public static async editNote(note: Note): Promise<Note> {
        const headers = new Headers();
        headers.append("Content-Type", "application/json");

        const myInit: RequestInit = {
            method: "POST",
            headers: headers,
            body: JSON.stringify(note),
        };

        const res = await fetch(BASEURL + "/note", myInit);
        if(!res.ok || res.status !== 200) {
            console.error("editNote: ERROR in API call");
            throw new Error("ERROR in API call");
        }
        return new Note(await res.json());
    }
    
    /**
     * Partage la note avec une liste d'utilisateur
     * @param noteId l'Id de la note 
     * @param noteId la liste des utilisateur avec lequels la note va être partagé
     * @returns un boolean pour savoir si la requete a été effectué
     */
    public static async ShareTo(noteId: string, userIds: string[]): Promise<boolean> {
        const headers = new Headers();
        headers.append("Content-Type", "application/json");     
        const body = {
            noteId : noteId,
            userIds : userIds
        }
        console.log ( "body", JSON.stringify(body))
        const myInit: RequestInit = {
            method: "POST",
            headers : headers,
            body: JSON.stringify(body),
        };
        const res = await fetch(BASEURL + "/note/ShareTo", myInit);
        if(!res.ok || res.status !== 200) {
            console.error("ShareTo: ERROR in API call");
            throw new Error("ERROR in API call");
        }
        return await res.ok;
        
    }


    /**
     * Supprime une note sur le serveur
     * @param noteId l'Id de la note qui doit être supprimée
     * @returns un booléen correspondant à si la note a été supprimée ou non
     */
    public static async deleteNote(noteId: string): Promise<boolean> {

        const myInit: RequestInit = {
            method: "DELETE",
        };

        const url = BASEURL +
                    "/note/" +
                    noteId;

        const res = await fetch(url, myInit);
        if(res.status === 200 && res.ok) {
            return true;
        }
        throw new Error("ERROR in API call");
    }

    public static async getNotes(userId: string): Promise<Note[]> {


        const myInit: RequestInit = {
            method: "GET",
        };

        const res = await fetch(BASEURL + "/note/" + userId, myInit);
        const notes = await res.json();
        return notes.map((n: INote) => new Note(n));
    }
    /**
     * Recupère les utilisateurs avec lequels la note est partagé en fonction de l'id de la note
     * @param noteId l'Id de la note
     * @returns une liste de UserId
     */
    public static async getSharedUsersByNoteId(noteId: string): Promise<string[]> {

        const myInit: RequestInit = {
            method: "GET",
        };

        const res = await fetch(BASEURL + "/note/GetSharedUsers?noteId=" + noteId, myInit);
        if(!res.ok || res.status !== 200) {
            console.error("getNotes: ERROR in API call");
            throw new Error("ERROR in API call");
        }
        const notes = await res.json();
        return notes;
    }
}